module.exports = __webpack_public_path__ + "static/img/Limpieza.efde69aa.png";